import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { toAppPath } from './history';

// The app passes absolute same-origin URLs (from getInternalWebsiteBaseUrl) as
// `to`. react-router 3's Link accepted those; react-router v5 resolves a string
// `to` relative to the current path and mangles an absolute URL. Normalize `to`
// to a path first, then delegate to the v5 Link.
export const Link = ({ to, ...rest }) => <RouterLink to={toAppPath(to)} {...rest} />;

export default Link;
